<template>
  <v-combobox
    dense
    prepend-icon="mdi-tag"
    outlined
    multiple
    item-value="id"
    item-text="name"
    :items="tagsList"
    label="الوسوم"
    v-model="tags"
    :loading="loading"
    @change="$emit('input', $event)"
    :search-input.sync="tagsSearchInput"
    small-chips
    :error-messages="errors.name"
  ></v-combobox>
</template>


<script>
/**
 * ### you can use this component in this way:
 * let tagsIds = this.$refs.tagsInput.submit();
 */
export default {
  name: 'tags-input',
  props: ['record'],


  data: function () {
    return {
      tags: [],
      loading: false,
      tagsList: [],
      tagsSearchInput: null,
      errors: {}
    };
  },


  watch: {
    'record'(record) {
      if (record && Array.isArray(record.tags)) {
        this.tagsList = record.tags;
        this.tags = this.tagsList;
      }
    },

    tagsSearchInput(query) {
      query != '' && this.fetchTags(query);
    }
  },


  methods: {
    fetchTags(query) {
      this.loading = true;

      this.axios.get('/admin/tags', { params: { q: query } })
        .then((response) => { this.tagsList = response.data.data; })
        .finally(() => { this.loading = false; });
    },

    /**
     * submit the tags to the server
     * 
     * @return array of tags ids
     */
    async submit() {
      this.loading = true;
      let tagsIds = [];

      for (let index = 0; index < this.tags.length; index++) {
        const tag = this.tags[index];

        // tag already submitted to server
        if (typeof tag != 'string') {
          tagsIds.push(tag.id);
          continue;
        }

        // send the tag to the server
        await this.axios.post('/admin/tags', { name: tag })
          .then((response) => {
            tagsIds.push(response.data.record.id);
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            }

            this.$bus.$emit("showSnackbar", {
              text: `برجاء مراجعة بيانات الوسم ${tag}`,
              color: "accent",
            });

            this.loading = false;
            throw new Error;
          });
      }

      this.loading = false;
      return tagsIds;
    }
  }
}
</script>